module.exports = __webpack_public_path__ + "img/crm.92eea249.jpg";